import { connect } from 'react-redux'
import filter from 'lodash/filter'
import at from 'lodash/at'

import ServicesSelector from '../../components/forms/services-selector'

import { fetchServicesForWorkOrder } from '../../actions/services'
import { fetchWorkOrder } from '../../actions/work-orders'

function mapStateToProps (state, ownProps) {
  const orderedServices = at(state.services, state.services.ids)

  return {
    commonServices: filter(orderedServices, { common: true }),
    otherServices: filter(orderedServices, { common: false }),
    ...ownProps
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchWorkOrder(ownProps.workOrderId))
    .then(() => dispatch(fetchServicesForWorkOrder(ownProps.workOrderId)))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicesSelector)



// WEBPACK FOOTER //
// ./src/containers/forms/services-selector-container.js